<div class="mx-0 px-2 py-3 row wrapper">
  <ng-content></ng-content>
</div>
